import { ApiClient } from '@ifixit/carpenter-utils';
import { _js } from '@ifixit/utils/localize';

/**
 * A human-readable message for a failed editor API call: the not-logged-in
 * case, an optional 409 explanation, the server's own message when it sent
 * one, then a generic fallback.
 */
export function apiErrorMessage(
   error: Error,
   messages: { login?: string; conflict?: string } = {}
): string {
   if (ApiClient.isInvalidLoginError(error)) {
      return messages.login ?? _js('Log in to save your changes.');
   }
   if (ApiClient.isApiError(error)) {
      if (messages.conflict && error.response?.status === 409) {
         return messages.conflict;
      }
      const data = error.response?.data as
         | { message?: string; errors?: { message?: string }[] }
         | undefined;
      // Validation failures carry the useful text per field; the top-level
      // message is just "Validation failed". A multi-field 422 reports
      // every field, not just the first.
      const fieldMessages = (data?.errors ?? [])
         .map(fieldError => fieldError.message)
         .filter((message): message is string => Boolean(message));
      if (fieldMessages.length > 0) {
         return fieldMessages.join(' ');
      }
      if (data?.message) {
         return data.message;
      }
   }
   return error.message || _js('Something went wrong. Please try again.');
}
